if (!customElements.get('view-more')) {
  customElements.define(
    'view-more',
    class ViewMore extends HTMLElement {
      constructor() {
        super()

        this.originalHtml = this.innerHTML
        this.words = this.textContent.trim().split(' ')
        this.maxLines = parseInt(this.dataset.maxlines)
        this.link = this.dataset.link

        this.classList.remove('no-load')
        this.calculate()
        this.classList.add('load')

        window.addEventListener('resize', () => {
            this.calculate(true)
        })
      }

      calculate(force) { 
        if (this.classList.contains('load') && !force) return
        
        const smallHtml = []
        const lineHeight = parseFloat(window.getComputedStyle(this).getPropertyValue('line-height'))

        const href = this.link ? `href="${this.link}"` : ''
        const tag = this.link ? 'a' : 'span'
        const moreButton = `<${tag} ${href} class="view-more__link">Leer más</${tag}>`
        const contentSEO = `<div style="display:none;" class="seo-hidden">${this.originalHtml}</div>`

        for (var i = 0; i < this.words.length; i++) {
          smallHtml.push(this.words[i])
          this.innerHTML = smallHtml.join(' ')

          const divHeight = this.offsetHeight
          const lines = Math.round(divHeight / lineHeight)

          if (lines > this.maxLines) {
            this.innerHTML = smallHtml.join(' ') + '... '
            if (this.classList.contains('no-link') == false) { 
              this.innerHTML = this.innerHTML + moreButton
            }
            break
          }
        }

        let smallHtmlLines = Math.round(this.offsetHeight / lineHeight)
        while (smallHtmlLines > this.maxLines) {
          smallHtml.splice(-1)
          this.innerHTML = smallHtml.join(' ') + '... '
          if (this.classList.contains('no-link') == false) { 
            this.innerHTML = this.innerHTML + moreButton
          }
          smallHtmlLines = Math.round(this.offsetHeight / lineHeight)
        }

        this.innerHTML = this.innerHTML + contentSEO

        this.createEvents()
      }

      createEvents() { 
        if (!this.link && this.classList.contains('no-link') == false) {
          const viewMoreLink = this.querySelector('.view-more__link')
          viewMoreLink.addEventListener('click', e => {
            e.preventDefault()
            const href = this.link ? `href="${this.link}"` : ''
            const tag = this.link ? 'a' : 'span'
            const lessButton = `<${tag} ${href} class="view-less__link">Leer menos</${tag}>`
            this.innerHTML = this.originalHtml + lessButton
            this.createEventsLess()
          })
        }
      }
      
      createEventsLess(){
        if (!this.link && this.classList.contains('no-link') == false) {
          const viewLessLink = this.querySelector('.view-less__link')
          viewLessLink.addEventListener('click', e => {
            e.preventDefault()
            this.calculate(true)
          })
        }
      }
    }
  )
}